<!--  -->
<template>
  <div class="training-area-wrap">
    <hardware-block-editor
      :class="['blockly-editer', { 'blockly-editer-open': !sidebarSwitch }]"
      :workspaceIsVisible="workspaceIsVisible"
      v-model="Blocks"
      :project-id="projectId"
      :trainingId="trainingId"
      :xml-data="{
        name: Project.ProjectName,
        type: 1,
        path: Project.BlocksFileUrl,
      }"
      :save-flag="saveFlag"
      v-bind="$attrs"
      v-on="$listeners"
      ref="blockly"
      @getMedia="getMedia"
      :Media.sync="Media"
    >
      <!-- :Media.sync="Media" -->
      <!-- 基础积木 -->
      <!-- 自定义的预加载模块，需要事先添加相应的 gta_ai_event.js  -->
      <category name="%{BKY_CATEVENT}" colour="50">
        <block type="gta_ai_event_print">
          <value name="NAME">
            <shadow type="gta_ai_event_item"> </shadow>
          </value>
        </block>
        <block type="gta_ai_event_4"></block>
        <block type="gta_ai_event_5"></block>
        <block type="gta_define_robot_B">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
        </block>
        <block type="gta_robot_B_close">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
        </block>
        <block type="gta_robot_B_get_battery">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
        </block>
        <block type="gta_robot_B_get_version">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
        </block>
        <block type="gta_ai_event_6">
          <value name="NAME">
            <shadow type="gta_ai_event_item"> </shadow>
          </value>
        </block>
        <block type="gta_ai_event_8"> </block>
      </category>

      <!-- 控制 -->
      <category name="%{BKY_CATLOOPS}" colour="%{BKY_LOOPS_HUE}">
        <!-- <block type="logic_null"></block> -->
        <block type="controls_repeat_ext">
          <value name="TIMES">
            <shadow type="math_number">
              <field name="NUM">20</field>
            </shadow>
          </value>
        </block>

        <block type="gta_controls_whileUntil">
          <value name="NAME1">
            <shadow type="logic_null"></shadow>
          </value>
        </block>
        <!-- <block type="controls_whileUntil"></block> -->

        <block type="controls_for">
          <value name="FROM">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="TO">
            <shadow type="math_number">
              <field name="NUM">10</field>
            </shadow>
          </value>
          <value name="BY">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
        </block>
        <block type="controls_forEach">
          <value name="LIST">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <block type="break_continue"></block>
        <!-- <block type="controls_flow_statements"></block> -->

        <!-- 逻辑  start-->
        <block type="controls_if">
          <value name="IF0">
            <shadow type="logic_null"></shadow>
          </value>
        </block>
        <block type="logic_negate">
          <value name="BOOL">
            <shadow type="logic_null">
              <field></field>
            </shadow>
          </value>
        </block>
        <!-- <block type="logic_boolean"></block> -->
        <!-- 三元表达式 -->
        <block type="logic_ternary">
          <value name="IF">
            <shadow type="logic_null"></shadow>
          </value>
          <value name="THEN">
            <shadow type="gta_ai_controls_item"></shadow>
          </value>
          <value name="ELSE">
            <shadow type="gta_ai_controls_item"></shadow>
          </value>
        </block>
        <block type="waiting_time"></block>
        <!-- 时间积木-->
        <!-- 逻辑  end-->
      </category>

      <!-- math 运算 -->
      <category name="%{BKY_CATMATH}" colour="%{BKY_MATH_HUE}">
        <!-- <block type="gta_ai_add_1" ></block> -->
        <!-- 数字 -->
        <!-- <block type="math_change"></block> -->
        <block type="math_number">
          <field name="NUM">123</field>
        </block>

        <!-- 加法 -->
        <block type="math_arithmetic_add">
          <value name="A">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
        </block>
        <!-- 比较> = <  -->
        <block type="logic_compare_1">
          <value name="A">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>

        <block type="logic_operation">
          <value name="A">
            <shadow type="logic_null">
              <field></field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="logic_null">
              <field></field>
            </shadow>
          </value>
        </block>
        <!-- 真/假 成立/不成立 -->
        <block type="logic_boolean"></block>

        <!-- 1~100随机数 -->
        <block type="math_random_int">
          <value name="FROM">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="TO">
            <shadow type="math_number">
              <field name="NUM">100</field>
            </shadow>
          </value>
        </block>

        <!-- 取余-->
        <block type="math_modulo">
          <value name="DIVIDEND">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
          <value name="DIVISOR">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>
        <!-- 绝对值、平方根、对数、log ln 指数的运算 -->
        <block type="math_single">
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>

        <!-- sin/cos 等三角函数 -->
        <block type="math_trig">
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM">45</field>
            </shadow>
          </value>
        </block>

        <!-- π、e等重要常量 -->
        <block type="math_constant"></block>
        <!-- 奇数或者偶数  -->
        <block type="math_number_property">
          <value name="NUMBER_TO_CHECK">
            <shadow type="math_number">
              <field name="NUM">0</field>
            </shadow>
          </value>
        </block>
        <!-- 四舍五入 -->
        <block type="math_round">
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM">3.1</field>
            </shadow>
          </value>
        </block>
        <!-- 随机数 -->
        <block type="math_random_float"></block>
        <block type="math_on_list">
          <value name="LIST">
            <block type="variables_get">
              <field name="VAR">{listVariable}</field>
            </block>
          </value>
        </block>
        <!-- 将50限制在1-100之间 -->
        <block type="math_constrain">
          <value name="VALUE">
            <shadow type="math_number">
              <field name="NUM">50</field>
            </shadow>
          </value>
          <value name="LOW">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="HIGH">
            <shadow type="math_number">
              <field name="NUM">100</field>
            </shadow>
          </value>
        </block>

        <!-- 方位角 -->
        <block type="math_atan2">
          <value name="X">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="Y">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
        </block>
      </category>

      <!-- 变量 -->
      <category
        name="%{BKY_CATVARIABLES}"
        colour="%{BKY_VARIABLES_HUE}"
        custom="VARIABLE"
      ></category>

      <!-- 函数 -->
      <category
        name="%{BKY_CATFUNCTIONS}"
        colour="%{BKY_PROCEDURES_HUE}"
        custom="PROCEDURE"
        class="PROCEDURE"
      ></category>

      <!-- <category name="媒体" custom="upload_pic" v-if="false">
        <block type="gta_ai_event_6"></block>
      </category> -->

      <category name="行驶" colour="%{BKY_DATATYPE_HUE}">
        <block type="gta_robot_B_drive_wheels">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
        </block>
        <block type="gta_robot_B_chassis_move">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
        </block>

        <!-- <block type="gta_move_in_open_loop"></block>
        <block type="gta_straight_move"></block>
        <block type="gta_robot_turn"></block> -->
      </category>

      <category name="姿势" colour="%{BKY_DATATYPE_HUE}">
        <block type="gta_robot_B_arm_recenter">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
        </block>
        <block type="gta_robot_B_arm_move_to">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
        </block>
        <!-- <block type="gta_robot_B_gripper_get_status">
          <value name="ROBO T">
            <shadow type="gta_robot"></shadow>
          </value>
        </block> -->
        <block type="gta_robot_B_gripper_close">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
        </block>
        <block type="gta_robot_B_gripper_open">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
        </block>
        <!-- <block type="gta_robot_B_servo_get_angle">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
        </block> -->
        <block type="gta_robot_B_servo_move_to">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
        </block>
      </category>

      <!-- <category name="灯光" colour="%{BKY_DATATYPE_HUE}"> 
        <block type="gta_robot_B_led_set_led">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
        </block>
      </category> -->
      <!-- 
      <category name="声音" colour="%{BKY_DATATYPE_HUE}">
        <block type="gta_robot_display_audio">
          <value name="NAME">
            <shadow type="gta_ai_event_item"> </shadow>
          </value>
        </block>
        <block type="gta_robot_tts"></block>
        <block type="gta_robot_play"></block>
        <block type="gta_get_play_status"></block>
        <block type="gta_set_volume"></block>
        <block type="gta_get_volume"></block>
      </category> -->

      <category name="摄像头" colour="%{BKY_DATATYPE_HUE}">
        <block type="gta_robot_B_display_video">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
        </block>
        <block type="gta_robot_B_get_camera_image">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
        </block>
      </category>

      <category name="技能" colour="%{BKY_VARIABLES_HUE}">
        <block type="gta_robot_B_detect_color_blob">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
          <value name="LOW">
            <shadow type="gta_ai_event_item"> </shadow>
          </value>
          <value name="HIGH">
            <shadow type="gta_ai_event_item"> </shadow>
          </value>
        </block>
        <block type="gta_robot_hsv"></block>
        <block type="gta_robot_B_move_along_line">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
        </block>
        <block type="gta_robot_B_detect_pattern">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
        </block>
        <block type="gta_robot_B_move_to_pattern">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
        </block>
        <block type="gta_robot_B_detect_face">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
        </block>
        <block type="gta_robot_B_detect_qrcode">
          <value name="ROBOT">
            <shadow type="gta_robot"></shadow>
          </value>
        </block>
      </category>
      <sep></sep>
    </hardware-block-editor>
  </div>
</template>

<script>
import HardwareBlockEditor from '@/components/hardwareBlockEditor/HardwareBlockEditor.vue'
import bus from '@/utils/bus'
import BLOCK from '@/axios/trainingCenter/AiEditor/blocks.js'
import AI_EDITOR from '@/axios/personalSpace/AiEditor/blocks.js'
import { mapGetters } from 'vuex'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'HardwareBlockIndex',
  components: { HardwareBlockEditor },
  props: {
    // 实训ID
    trainingId: {
      type: String,
      default: null,
    },
    // 项目ID
    projectId: {
      type: String,
      default: null,
    },
    // xml 保存相关数据
    xmlData: {
      type: Object,
      default: () => {
        return {
          str: '',
          name: '',
          type: 1,
          path: '',
        }
      },
    },
    // 保存指令 flag，保存指令传达，prevSaveWorkSpaceXmlTxt 将会保存一次，用来比较是否有所改变
    saveFlag: {
      type: Number,
      default: 0,
    },
    // 语言信息
    langMsg: {
      type: Object,
      default: () => {
        // return BlocklLangMsg.en;
      },
    },
    // 颜色主题
    theme: {
      type: Object,
      default: () => {
        return {}
      },
    },
    // 渲染器
    renderer: {
      type: String,
      default: 'gta',
    },
    // 自定义模块添加
    blocks: {
      type: Object,
      default: () => {
        return {}
      },
    },
    // stepOperate: {
    //   type: String,
    //   default: ""
    // }
  },
  data() {
    return {
      workspaceIsVisible: true,
      sidebarSwitch: true,
      homeWorkStatus: false,
      beMark: false, //遮罩层
      hasAttr: false,
      scoreTitle: '实训评分',
      Media: [],
      mediaGotten: 0,
      trainingDetails: { status: 2 }, // 需要从接口获取
      reportInfo: {}, //实训报告信息
      guideBookSwitch: {
        type: 'guideBook',
        sidebarSwitch: true,
      },
      codeRunSwitch: {
        type: 'codeRun',
        sidebarSwitch: true,
      },
      buildingBlocksType: 0, //保存的积木类型：1项目题解，2项目题面，3基础模型，4提交作业
      Project: {
        ProjectId: '00000000-0000-0000-0000-000000000000',
        ProjectName: 'AI 人形机器人',
        BlocksFileUrl: '',
      },
      projectTask: {
        trainingName: '', // 实训名称
        points: '', // 技能点
        presetGoal: '', // 预设目标
        selfRatedScore: '', // 学生自评分数
        score: '', // 老师评分
        appraise: '', // 老师评语
      },
      NewProject: {
        ProjectId: '00000000-0000-0000-0000-000000000000',
        ProjectName: '新建项目',
        BlocksFileUrl: '',
      },
      MyProjectList: {
        PageSize: 10000, // TODO:暂全部显示
        Items: [],
      },
      Cases: [],
      taskInfo: null, // 作业任务信息;
      submitObj: {
        //学生提交字段
        ProjectId: '', //项目id
        ProjectName: '', //项目名称
        ProjectContent: '', // 项目描述 ,
        points: '', //技能点
        presetGoal: '', //预设目标
        selfRatedScore: '', //自评分数;
      },
      buildingBlocksTypeObj: {
        //积木类型
        answer: 1, //1项目题解
        question: 2, //2项目题面
        save: 3, //3基础模型保存
        homework: 4, //4提交作业
      },
      popupActive: '',
      searchKey: '',
      Blocks: { TotalCount: 0, Items: [] },
      isComplete: 1, //1完成，0未完成
      isPublic: 1, //1完成，0未完成
      TrainId: '',
      CourseHourId: null,
      CourseName: null,
      leaveType: '', //跳转的路由来源
      Status: null,
      scored: null, //判断是否已评分状态进来
      score: null, //具体分数
      // codeText: "", //运行结果，在runCode组件中处理;
      rightSideVal: 'guideBook',
      iconSubmitCode: require('@/assets/images/ai-editor/submit-code.png'),
      iconExercise: require('@/assets/images/ai-editor/submit-exercise.png'),
      switchIcon: require('@/assets/images/ai-editor/switch.png'),
    } //data end
  },
  computed: {
    ...mapGetters([
      'accountInfo',
      'studentId',
      'hasRunSuccess',
      'Train',
      'curriculumId',
      'userRole',
    ]),
    status() {
      let Train = this.Train
      return Train.status
    },
  },
  watch: {},

  created() {
    let self = this
  },
  mounted() {
    let self = this
    this.popupActive = ''
    //监听 转换 代码模式/积木模式
    bus.$on('changeMode', () => {
      self.changeMode()
    })

    // 监听调用重绘
    bus.$on('onSidebarSwitch', (switchObj) => {
      self.sidebarSwitchHandle(switchObj)
    })
  },
  methods: {
    /**
     *
     *
     *
     * 运行功能处理模块
     */
    // runHandle() {
    //   // let codeText = this.$refs.blockly.runHandle();/
    //   // this.$store.state.blocklyHome.codeText = codeText; //原始的积木文本
    //   // this.codeText = codeText;
    //   // return codeText;
    // },
    changeMode() {
      var btnToCode = document.getElementById('btnCodeEditer')
      this.workspaceIsVisible = !this.workspaceIsVisible
      bus.$emit('getWorkspaceIsVisible', this.workspaceIsVisible)
      // 触发内部转换代码按钮
      if (!this.workspaceIsVisible) {
        btnToCode.click()
      }
    },
    getMedia(pageIndex) {
      let { trainingId, accountInfo, projectId } = this,
        data = {}
      //实训中心里根据trainingId获取媒体积木
      if (trainingId) {
        data = {
          trainingId,
          userId: accountInfo.userId,
        }
        return BLOCK.getMediaByTrainingId(data).then((result) => {
          if (result.isSuccess) {
            this.Media = result.data
            //图片列表
            this.mediaGotten = 1
          }
        })
      } else if (projectId) {
        //ai-T编辑器里根据trainingId获取媒体积木
        data = {
          projectId,
        }

        return AI_EDITOR.getMediaByTrainingId(data).then((result) => {
          if (result.isSuccess) {
            this.Media = result.data
            //图片列表
            this.mediaGotten = 1
          }
        })
      }
    },
    // 重绘工作区大小
    sidebarSwitchHandle(switchObj) {
      // this.sidebarSwitch = sidebarSwitch;
      this.sidebarSwitch = switchObj.sidebarSwitch
      if (window) {
        this.$nextTick(() => {
          // window.dispatchEvent(new Event("resize"));
          var resizeEvent = window.document.createEvent('UIEvents')
          resizeEvent.initUIEvent('resize', true, false, window, 0)
          window.dispatchEvent(resizeEvent)
        })
      }
    },
    // 重命名
    // saveCopyProject() {},
    // 项目案例
    // caseToWorkspace(idx) {
    //   var ProjectCase = this.Cases[idx],
    //     ProjectName = ProjectCase.CaseName,
    //     xmlText = ProjectCase.xmlText;

    //   // 创建一个新的 Project
    //   // TODO:利用项目 ID 全置 0 来做项目案例前期标记
    //   this.Project.ProjectId = this.Placeholder.ProjectId;
    //   this.Project.ProjectName = ProjectName;
    //   this.Project.BlocksFileUrl = null;

    //   // 保存时候会用到
    //   this.NewProject.ProjectName = ProjectName;

    //   // 打开 XML
    //   this.$refs.blockly.createBlocksByWorkspaceXML(xmlText, true);
    //   this.$refs.blockly.workspace.clear();
    //   this.$refs.blockly.textToWorkspace(xmlText);

    //   // 关闭弹窗
    //   this.cancelPopup();
    // },
  }, //methods end
  updated() {}, //生命周期 - 更新之后
  destroyed() {
    bus.$off('changeMode')
  }, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
@import '~@/assets/styles/practical_training_blockly_editer.scss';
.on {
  display: inline-block;
}

.off {
  display: none;
}
</style>
